import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const CalendarSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default CalendarSVG;
